// Kontextová nabídka - objekt pro vykreslení
<template>
  <v-card>
    <v-card-subtitle v-if="false">{{ Content.title }}</v-card-subtitle>
    <v-btn
      v-for="(item, index) in Content.items"
      :key="index"
      @click="item.action"
      small
      color="toolBar1"
      class="ma-2"
      >{{ item.label }}</v-btn
    >
  </v-card>
</template>

<script>
export default {
  props: {
    Content: Object,
  },
};
</script>